import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import { Button, CircularProgress, TextField } from '@material-ui/core';
import { NotificationManager } from 'react-notifications';
import { validateContactForm } from '../../utils/validators/validateForm';
import { withTheme } from '@material-ui/core/styles';
import { FormattedMessage, injectIntl } from 'react-intl';

import icon1 from 'assets/images/icon/phone.png';
import icon2 from 'assets/images/icon/mail.png';
import icon3 from 'assets/images/icon/skype.png';

import fb from '../../assets/images/fb.png';
import logowhite from "../../assets/images/new-img/logowhite.png"
import link from "../../assets/images/new-img/link.png"
import insta from '../../assets/images/inta-.png';

import AppLinks from '../../components/About/AppLinks';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from "react-icons/fa6";
import { LuFacebook } from "react-icons/lu";
import { LuLinkedin } from "react-icons/lu";

class Contact extends Component {
    state = {
        data: '',
        loader: false,
        nameError: '',
        emailError: '',
        messageError: '',
        name: '',
        email: '',
        message: ''
    };
    componentDidMount() {
        document.title = 'Contact Us';
        document.keywords = 'contact-us';
        document.description = 'contact-us';
    }
    componentWillUnmount() {
        document.title = '';
        document.keywords = '';
        document.description = '';
    }

    submitContact = () => {
        const { name, email, message } = this.state;
        if (validateContactForm({ name, email, message }, this.handleError)) {
            this.setState({ loader: true });
            this.props.contactUsAction(
                {
                    name,
                    email,
                    message
                },
                this.onDone
            );
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="enterValidData"
                    defaultMessage="Enter valid data"
                />,
                'Error'
            );
        }
    };

    handleError = params => {
        this.setState(params);
    };

    onDone = (success, data) => {
        if (success) {
            this.setState({ loader: false });
            NotificationManager.success(
                <FormattedMessage
                    id="contactThanks"
                    defaultMessage="Thanks for contacting us! we will get back soon.."
                />,
                <FormattedMessage
                    id="messageSent"
                    defaultMessage="Message Sent"
                />
            );
            this.setState({ name: '', email: '', message: '' });
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="someError"
                    defaultMessage="Some Error Occurred, try again later"
                />,
                'Error'
            );
        }
    };

    renderButton = () => {
        if (this.state.loader) {
            return <CircularProgress />;
        }
        return (
            <Button
                variant="raised"
                color="primary"
                className="jr-btn  contact-btn"
                onClick={this.submitContact}
            >
                <FormattedMessage
                    id="sendMessage"
                    defaultMessage="Send Message"
                />
            </Button>
        );
    };
    render() {
        const {
            loader,
            nameError,
            emailError,
            messageError,
            email,
            name,
            message
        } = this.state;
        const { settings } = this.props;
        console.log("link", settings)
        const { formatMessage } = this.props.intl;
        return (
            <div style={{ minHeight: 500 }}>

                <div>

                    <div className="inn-page-bg">
                        <div className="container">
                            <div className="row">
                                <div className="inn-pag-ban_div">
                                </div>
                                <div className="inn-pag-ban_div2">
                                </div>
                                <div className="inn-pag-ban">
                                    <h2><span>Contact Info</span></h2>
                                    <hr className="line">
                                    </hr>
                                    <p class="refer_class">All in One Place so it’s Nice and Convenient
                                    </p>
                                </div>
                                <div class="icon_down"></div>
                            </div>
                        </div>
                    </div>
                    <div className="con-page">
                        <div className="container">
                            <div className="con-page-ri">
                                <div className="con-com">
                                    <h4 className="con-tit-top-o">
                                        Address & Contact Info
                                    </h4>
                                    <p>{settings.constants.address_line1}</p>{' '}
                                    {settings.constants.phone_number && (
                                        <span>
                                            <img src={icon1} alt="phone" />
                                            Phone: xxxxxxxxxx
                                            {/* {settings.constants.phone_number} */}
                                        </span>


                                    )}
                                    {/* {settings.constants.skypeid && (
                                    <span>
                                        <img src={icon3} alt="phone" />
                                        Skype: {settings.constants.skypeid}
                                    </span>
                                )} */}
                                    {settings.constants.admin_email && (
                                        <span>
                                            <img src={icon2} alt="mail" />
                                            Email: admin@ezprohome.com
                                            {/* {settings.constants.admin_email} */}
                                        </span>
                                    )}
                                    <div style={{
                                        marginTop: '20px'
                                    }}>
                                        <h4>Follow us on</h4>
                                        <p>We are on various social media platforms:</p>
                                        <div className="container">
                                            <div className="row">
                                                <div className="foot-social">
                                                    <div>

                                                        <ul>
                                                            <li>
                                                                <a
                                                                    href={
                                                                        settings.constants.facebook}
                                                                >
                                                                    {/* <i className="fab fa-facebook-f fb1" />{' '} */}

                                                                    {/* <img src={fb} /> */}
                                                                    <FaFacebookF size={17} />
                                                                    {/* <LuFacebook size={35} /> */}
                                                                </a>{' '}
                                                            </li>
                                                            <li>
                                                                <a
                                                                    href="https://twitter.com/ezprohome"
                                                                >
                                                                    {/* <i className="fab fa-facebook-f fb1" />{' '} */}
                                                                    {/* <img src={logowhite} className="tuter" /> */}
                                                                    <FaXTwitter size={17} />
                                                                </a>{' '}
                                                            </li>
                                                            <li>
                                                                <a
                                                                    href={
                                                                        settings.constants.instagram
                                                                    }
                                                                >
                                                                    {/* <i className="fa fa-instagram tw1" />{' '} */}
                                                                    {/* <img src={insta} style={{
                                                                    outline: '1'
                                                                }} className="tuter" /> */}
                                                                    <FaInstagram size={17} />
                                                                </a>{' '}
                                                            </li>
                                                            <li>
                                                                <a
                                                                    href={
                                                                        settings.constants.linkedin}
                                                                >
                                                                    {/* <i className="fa fa-youtube gp1" />{' '} */}

                                                                    {/* <img src={link} className="tuter" style={{ aspectRatio: "3/4" }} /> */}
                                                                    <FaLinkedinIn size={17} />
                                                                    {/* <LuLinkedin size={35} /> */}
                                                                </a>{' '}
                                                            </li>

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="con-com">
                                <div className="cpn-pag-form">
                                    <form
                                        className="form-new"
                                        noValidate
                                        autoComplete="off"
                                        id="contact"
                                    >
                                        <h4>Support and Contact Enquiry</h4>
                                        <p>
                                            We are here to help you anytime,
                                            we promise to get back to you right away.Unless it’s not normal business hours or we have some good excuse.
                                        </p>
                                        <div className="row text-left">
                                            <div className="col-md-12 col-xs-12">
                                                <TextField
                                                    error={
                                                        nameError ? true : false
                                                    }
                                                    helperText={nameError}
                                                    type="text"
                                                    name="name"
                                                    className="login-form-textfield"
                                                    id="name"
                                                    fullWidth
                                                    label={formatMessage({
                                                        id: 'name'
                                                    })}
                                                    margin="normal"
                                                    onChange={event => {
                                                        this.setState({
                                                            name:
                                                                event.target
                                                                    .value,
                                                            nameError: ''
                                                        });
                                                    }}
                                                    value={name}
                                                    disabled={
                                                        loader ? true : false
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-12 col-xs-12">
                                                <TextField
                                                    error={
                                                        emailError
                                                            ? true
                                                            : false
                                                    }
                                                    helperText={emailError}
                                                    type="email"
                                                    name="email"
                                                    className="login-form-textfield"
                                                    id="email"
                                                    fullWidth
                                                    label={formatMessage({
                                                        id: 'email'
                                                    })}
                                                    onChange={event => {
                                                        this.setState({
                                                            email:
                                                                event.target
                                                                    .value,
                                                            emailError: ''
                                                        });
                                                    }}
                                                    margin="normal"
                                                    value={email}
                                                    disabled={
                                                        loader ? true : false
                                                    }
                                                />
                                            </div>
                                            <div className="col-md-12 col-xs-12">
                                                <TextField
                                                    error={
                                                        messageError
                                                            ? true
                                                            : false
                                                    }
                                                    helperText={messageError}
                                                    type="text"
                                                    name="message"
                                                    className="login-form-textfield"
                                                    id="message"
                                                    fullWidth
                                                    label={formatMessage({
                                                        id: 'message'
                                                    })}
                                                    rows={10}
                                                    onChange={event => {
                                                        this.setState({
                                                            message:
                                                                event.target
                                                                    .value,
                                                            messageError: ''
                                                        });
                                                    }}
                                                    margin="normal"
                                                    value={message}
                                                    disabled={
                                                        loader ? true : false
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-12 col-xs-12">
                                                <div className="mt-3">
                                                    {this.renderButton()}
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div> */}
                                {/* <div className="con-com con-pag-map con-com-mar-bot-o">
                                <h4 className="con-tit-top-o">Touch with us</h4>
                                <p>{settings.constants.address_line1}</p>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6290413.804893654!2d-93.99620524741552!3d39.66116578737809!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x880b2d386f6e2619%3A0x7f15825064115956!2sIllinois%2C+USA!5e0!3m2!1sen!2sin!4v1469954001005"
                                    allowFullScreen=""
                                />
                            </div> */}
                            </div>
                        </div>
                    </div>
                </div>

                <AppLinks settings={this.props.settings} />
            </div>

        );
    }
}
const mapStateToProps = ({ settings }) => {
    return { settings: settings };
};
const composedComponent = compose(
    withTheme(),
    connect(mapStateToProps, actions)
);

export default composedComponent(injectIntl(Contact));



// WEBPACK FOOTER //
// ./src/views/Page/Contact.jsx